import script from "./LoaderView.vue?vue&type=script&setup=true&lang=js"
export * from "./LoaderView.vue?vue&type=script&setup=true&lang=js"

import "./LoaderView.vue?vue&type=style&index=0&id=d57462fe&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LEGION\\Desktop\\SONNAR\\proiBueno\\virgen\\reppsoc-ppqy9-portaltuturesweb\\reppsoc-ppqy9-portaltuturesweb\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d57462fe"]])

export default __exports__